import { useDispatch, useSelector } from "react-redux"
import {
    usePost,
} from "../../api/reactQueryCustomHooks"
import { apiRoute, GetLoginCredentialDb, linksUrl } from "../../constants/enum"
import {
    ErrorCard,
    LoadingCard,
    MainContainer,
    MasterGrid,
} from "../../components"
import {
    Button
} from "@heroui/react"
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import dayjs from "dayjs"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

import { useNavigate } from "react-router-dom"
import { useEffect, useMemo, useState } from "react"
import { format } from "date-fns";

const CreditDebitNoteReport = () => {
    let navigate = useNavigate()
    const { token, user } = useSelector((state) => state.auth)
    const { compCode, compName, isMultipleCompany, startDate, endDate, yearId } = useSelector((state) => state.company)
    const frDate = (date) => (date ? format(new Date(date), "yyyy-MM-dd") : null);
    const [billDate, setBillDate] = useState({
        fromDate: frDate(startDate) || null,
        toDate: frDate(endDate) || null
    })

    useEffect(() => {
        if (isMultipleCompany)
            navigate(linksUrl.dashboard.tradingDashboard)
    }, [])
    const columns = [
        { header: "Doc. Date", accessor: "Bill_date", type: "date", filterable: true, sortable: true },
        { header: "Vou No", accessor: "Vou_No", type: "text", filterable: true, sortable: true },
        { header: "Doc No", accessor: "Bill_No", type: "text", filterable: true, sortable: true },
        { header: "Type", accessor: "Entry_Type", type: "text", filterable: true, sortable: true },
        { header: "Party", accessor: "Party", type: "text", filterable: true, width: "150px", sortable: true },
        { header: "Pan", accessor: "Pan", type: "text", filterable: true, },
        { header: "Account", accessor: "Account", type: "text", filterable: true, width: "200px", sortable: true },
        { header: "GrossAmt", accessor: "GrossAmt", type: "number", filterable: false, align: "right", sortable: true },
        { header: "Discount", accessor: "DiscAmt", type: "number", filterable: false, align: "right", sortable: true },
        { header: "TXBl. Value", accessor: "Taxable_Value", type: "number", filterable: false, align: "right", sortable: true },
        { header: "CGST", accessor: "CGSTAmt", type: "number", filterable: false, align: "right", sortable: true },
        { header: "SGST", accessor: "SGSTAmt", type: "number", filterable: false, align: "right", sortable: true },
        { header: "IGST", accessor: "IGSTAmt", type: "number", filterable: false, align: "right", sortable: true },
        { header: "Total GST", accessor: "Total_GST", type: "number", filterable: false, align: "right", sortable: true },
        { header: "NetAmt", accessor: "NetAmt", type: "number", filterable: false, align: "right", sortable: true },
    ];



    const {
        isError,
        isPending,
        data = [],
        mutate: filterData
    } = usePost({
        url: apiRoute.transactionEntry.getCreditDebitData,
        queryKey: "Credit Invoice Data Details",

    })

    //console.log(GetLoginCredentialDb())
    const funFilterData = () => {
        filterData({
            data: {
                compcode: compCode.join(","),
                from_date: billDate?.fromDate,
                to_date: billDate?.toDate,
                bill_type: 'V'
            }
        })
    }

    // useEffect(() => {
    //     funFilterData();
    // }, [])

    const handleFilter = () => {
        funFilterData();
    }
    const handleClear = () => {
        setBillDate({
            fromDate: startDate || null,
            toDate: endDate || null
        })
        filterData({
            data: {
                compcode: compCode.join(","),
                from_date: startDate,
                to_date: endDate,
                bill_type: 'V'
            }
        })
    }
    const formatDate = (date) => {
        return new Date(date).toLocaleDateString("en-GB");
    };

    const formatNumber = (num) => {
        return Number(num || 0).toFixed(2);
    };

    // Calculate totals
    const totals = data.reduce((acc, item) => {
        acc.GrossAmt += item.GrossAmt || 0;
        acc.DiscAmt += item.DiscAmt || 0;
        acc.Taxable_Value += item.Taxable_Value || 0;
        acc.CGSTAmt += item.CGSTAmt || 0;
        acc.SGSTAmt += item.SGSTAmt || 0;
        acc.IGSTAmt += item.IGSTAmt || 0;
        acc.Total_GST += item.Total_GST || 0;
        acc.NetAmt += item.NetAmt || 0;
        return acc;
    }, {
        GrossAmt: 0,
        DiscAmt: 0,
        Taxable_Value: 0,
        CGSTAmt: 0,
        SGSTAmt: 0,
        IGSTAmt: 0,
        Total_GST: 0,
        NetAmt: 0
    })
    const thclass = 'px-2 py-1 border border-gray-300 '




    if (isError) {
        return <ErrorCard />
    }

    if (isPending) {
        return <LoadingCard />
    }


    return (
        <div>


            <MainContainer
                pageName="Debit Credit Note Report"
                info={[]}
                breadcrumbs={["Reports & view", "Debit Credit Note Report"]}
            >
                <div className="p-2 shadow mb-5">
                    {/* <div className="pb-1 text-sm font-semibold">
                        Inward Date
                    </div> */}
                    <div className="flex gap-2  flex-wrap sm:flex-nowrap md:flex-nowrap justify-center items-center gap-5 ">
                        <div className="flex no-wrap gap-5">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label={"From Date"}
                                    views={["day", "month", "year"]}
                                    size="small"
                                    format="DD/MM/YYYY"
                                    value={
                                        billDate.fromDate
                                            ? dayjs(billDate.fromDate)
                                            : billDate.fromDate
                                    }
                                    onChange={(newValue) => {
                                        setBillDate((prev) => {
                                            return {
                                                ...prev,
                                                fromDate: newValue != '' && newValue != 'Invalid Date' ?
                                                    dayjs(newValue).format("YYYY-MM-DD") : null,
                                            };
                                        });
                                    }}
                                    slotProps={{
                                        textField: { size: "small", },
                                    }}
                                />
                            </LocalizationProvider>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label={"To  Date"}
                                    views={["day", "month", "year"]}
                                    format="DD/MM/YYYY"
                                    size="small"
                                    value={
                                        billDate.toDate
                                            ? dayjs(billDate.toDate)
                                            : billDate.toDate
                                    }
                                    onChange={(newValue) => {
                                        setBillDate((prev) => {
                                            return {
                                                ...prev,
                                                toDate: newValue != '' && newValue != 'Invalid Date' ?
                                                    dayjs(newValue).format("YYYY-MM-DD") : null,
                                            };
                                        });
                                    }}
                                    slotProps={{
                                        textField: { size: "small", },
                                    }}
                                />
                            </LocalizationProvider>
                        </div>
                        <div className="flex no-wrap gap-5 justify-center items-center">
                            <Button onPress={handleFilter} className="font-semibold uppercase bg-slate-700 text-white" variant="solid" color="primary" size="sm" >Get Data</Button>
                            <Button onPress={handleClear} className="font-semibold uppercase " variant="solid" color="danger" size="sm" >Reset Date</Button>
                        </div>
                    </div>
                </div>
                {/* <div>

                    {
                        data && data.length > 0 ? (
                            <div>
                                <div className="flex flex-wrap sm:flex-nowrap md:flex-nowrap justify-between">
                                    <h2 className="text-blue-800  uppercase text-xs  font-semibold text-sm">Total Records : {data?.length || 0}</h2>
                                    <div className="flex gap-5 justify-end mb-2 ">
                                        <button
                                            onClick={() => exportToPDF(data, totals)}
                                            className="px-2 py-1 bg-green-600 text-white rounded-md text-sm font-semibold"
                                        >
                                            Export PDF
                                        </button>
                                        <button
                                            onClick={() => exportToExcel(data, totals)}
                                            className="px-2 py-1 bg-red-600 text-white rounded-md text-sm font-semibold"
                                        >
                                            Export Excel
                                        </button>
                                    </div>


                                </div>


                                <div style={{ overflowX: "auto" }}>
                                    <div className="max-h-[500px] overflow-auto border border-yellow-200 rounded-md">
                                        <table className="w-full bg-white uppercase font-semibold text-xs border-collapse">

                                            
                                            <thead className="  bg-yellow-100  text-center text-slate-700 sticky top-0 z-20" style={{ fontSize: "0.7rem" }}>
                                                <tr>
                                                    <th className={thclass}>No.#</th>
                                                    <th className={thclass}>Doc. Date</th>
                                                    <th className={thclass}>Vou No</th>
                                                    <th className={thclass}>Doc. No</th>
                                                    <th className={thclass}>Type</th>
                                                    <th className={`${thclass} min-w-[150px]`}>Party</th>
                                                    <th className={thclass}>PAN No</th>
                                                    <th className={`${thclass} min-w-[200px]`}>Account</th>
                                                    <th className={thclass}>GrossAmt</th>
                                                    <th className={thclass}>Discount</th>
                                                    <th className={thclass}>Txbl. Value</th>
                                                    <th className={thclass}>CGST</th>
                                                    <th className={thclass}>SGST</th>
                                                    <th className={thclass}>IGST</th>
                                                    <th className={thclass}>Total GST</th>
                                                    <th className={thclass}>NetAmt</th>
                                                    <th className={`${thclass} min-w-[150px]`}>Remark</th>
                                                    <th className={thclass}>Supply Type</th>
                                                </tr>
                                            </thead>

                                           
                                            <tbody>
                                                {data.map((item, index) => (
                                                    <tr key={index} className="hover:bg-yellow-50">
                                                        <td className={`${thclass} text-center font-bold`}>{index + 1}</td>
                                                        <td className={thclass}>{formatDate(item.Bill_date)}</td>
                                                        <td className={thclass}>{item.Vou_No}</td>
                                                        <td className={thclass}>{item.Bill_no}</td>
                                                        <td className={thclass}>{item.Entry_Type}</td>
                                                        <td className={`${thclass} min-w-[150px]`}>{item.Party}</td>
                                                        <td className={thclass}>{item.PAN}</td>
                                                        <td className={`${thclass} min-w-[200px]`}>{item.Account}</td>
                                                        <td className={`${thclass} text-right`}>{formatNumber(item.GrossAmt)}</td>
                                                        <td className={`${thclass} text-right`}>{formatNumber(item.DiscAmt)}</td>
                                                        <td className={`${thclass} text-right`}>{formatNumber(item.Taxable_Value)}</td>
                                                        <td className={`${thclass} text-right`}>{formatNumber(item.CGSTAmt)}</td>
                                                        <td className={`${thclass} text-right`}>{formatNumber(item.SGSTAmt)}</td>
                                                        <td className={`${thclass} text-right`}>{formatNumber(item.IGSTAmt)}</td>
                                                        <td className={`${thclass} text-right`}>{formatNumber(item.Total_GST)}</td>
                                                        <td className={`${thclass} text-right`}>{formatNumber(item.NetAmt)}</td>
                                                        <td className={`${thclass} min-w-[150px]`}>{item.Remark}</td>
                                                        <td className={thclass}>{item.SupllyType}</td>
                                                    </tr>
                                                ))}
                                            </tbody>

                                           
                                            <tfoot className="sticky bottom-0 bg-yellow-100  px-2 py-3  text-xs text-slate-700 font-bold z-20">
                                                <tr className="">
                                                    <td colSpan="8" className="text-right px-2 py-1 border">TOTAL</td>
                                                    <td className="text-right px-2 py-3 border">{formatNumber(totals.GrossAmt)}</td>
                                                    <td className="text-right px-2 py-3 border ">{formatNumber(totals.DiscAmt)}</td>
                                                    <td className="text-right px-2 py-3 border">{formatNumber(totals.Taxable_Value)}</td>
                                                    <td className="text-right px-2 py-3 border">{formatNumber(totals.CGSTAmt)}</td>
                                                    <td className="text-right px-2 py-3 border">{formatNumber(totals.SGSTAmt)}</td>
                                                    <td className="text-right px-2 py-3 border">{formatNumber(totals.IGSTAmt)}</td>
                                                    <td className="text-right px-2 py-3 border">{formatNumber(totals.Total_GST)}</td>
                                                    <td className="text-right px-2 py-3 borders">{formatNumber(totals.NetAmt)}</td>
                                                    <td colSpan="2"></td>
                                                </tr>
                                            </tfoot>

                                        </table>
                                    </div>
                                </div>
                            </div>
                        ) : <h2 className="text-center text-gray-400"    >No data Found</h2>}

                </div> */}
                {data && data.length>0?
                <MasterGrid
                    columns={columns}
                    data={data}
                    className={""}
                    showPaging={false}
                    pageSize={20}
                    expandableRow={false}
                    headClass={"bg-slate-200 border-1 border-slate-300"}
                    filterClass={"bg-gray-50 border-1 border-slate-300"}
                    style={{ border: "1px solid red" }}
                    exportHeader={{
                        companyName: compName.join(","),
                        reportName: `Date Wise Debit Note / Credit Note Detail From ${formatDate(billDate.fromDate)} To ${formatDate(billDate.toDate)}`,

                    }}
                ></MasterGrid>:<h2 className="text-slate-500 text-sm">No Records Found</h2>}
            </MainContainer>
        </div>
    )
}
export default CreditDebitNoteReport
